import React from 'react';
import RiddlePage from './components/RiddlePage';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <RiddlePage />
    </div>
  );
};

export default App;
